{
  "version": 1,
  "asset_id": "273e35c0-70aa-4fb6-90b8-6575756eb63d",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/273e35c0-70aa-4fb6-90b8-6575756eb63d/destination-roofing-owner-sales-team-crystal-river-fl-768w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/273e35c0-70aa-4fb6-90b8-6575756eb63d/destination-roofing-owner-sales-team-crystal-river-fl-768w.webp",
  "original_filename": "destination-roofing-owner-sales-team-crystal-river-fl-768w.webp",
  "size": 40218,
  "content_type": "image/webp",
  "created_at": "2026-07-21T15:42:45Z"
}
